import { render } from "./AttachmentsViewer.vue?vue&type=template&id=f400e234"
import script from "./AttachmentsViewer.vue?vue&type=script&lang=js"
export * from "./AttachmentsViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__